import { ClientJS } from 'clientjs';

export default function getDebugInfo() {
  const client = new ClientJS();
  const debugObj = { userAgent: client.getUserAgent() };

  return JSON.stringify(debugObj);
}